import axios from 'axios'
import { Loading } from 'element-ui'
import store from '@/store'
import utils from '@/utils/utils'
import LoadingManage from '@/utils/loadingManage'
let loadingInstance = null

const loadingManage = new LoadingManage({
    addCallback() {
        loadingInstance = Loading.service()
    },

    closeCallback() {
        loadingInstance?.close()
    }
})

export default class HttpRequest {
    constructor(baseURL) {
        this.baseURL = baseURL
        this.loadingInstance = null
    }

    createAxiosInstance(options) {
        const instance = axios.create({
            baseURL: this.baseURL,
            timeout: 2 * 60000,
            requireAuth: true, // 是否需要登录授权
            headers: {
                get: {
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                },
            },
            ...options
        })
        this.interceptors(instance)
        return instance
    }

    interceptors(instance) {
        instance.interceptors.request.use(async config => {
            loadingManage.add(config.hideLoading)
            if (config.requireAuth) {
                config.headers.token = await store.dispatch('user/getToken', { diableGetAuth: config.diableGetAuth })
            }
            let isBlob = config.isBlob;
            if (isBlob) {
                config.responseType = "blob";
            }
            return config
        }, error => {
            loadingManage.close()
            return Promise.reject(error)
        });
        instance.interceptors.response.use(response => {
            loadingManage.close()
            let { status, data, config } = response
            if (status === 200) {
                let isBlob = config.isBlob;
                let excludeRequestUrl = [
                    '/employee_induction/employee_induction/exportZipFile',
                    '/employee_induction/employee_induction/downZipFile',
                    '/employee_induction/employee_induction/downloadDengjiFile',
                    '/recruit/api/recruit/resume/download',
                    '/recruit/api/recruit/resume/downloadFind',
                    '/recruit/api/recruit/resume/downloadResumeDatabase',
                    '/recruit/api/recruit/resume/exportResumeDatabase',
                    '/recruit/api/recruit/position/company/list/download',
                    '/recruit/api/recruit/resume/export',
                    '/recruit/api/recruit/enterprise/export',
                    '/recruit/api/recruit/user/export',
                ]
                if (isBlob || excludeRequestUrl.includes(response.config.url)) {
                    console.log(response);
                    let contentDisposition = response.headers['content-disposition']
                    if (contentDisposition) {
                        let message = response.headers.message
                        if (message) {
                            message = JSON.parse(decodeURIComponent(message))
                        }
                        message && utils.messageBox({
                            type: 'success',
                            title: '下载完成',
                            message: `<div>${message?.msg}</div><div>下载的简历和联系方式只可用作企业内部招聘使用</div>`,
                            dangerouslyUseHTMLString: true,
                            duration: 4000
                        });
                    return Promise.resolve({
                        data,
                        fileName: decodeURIComponent(contentDisposition.split(';')[1].split('=')[1]),
                    })
                    } else {
                        let showErr = data => {
                            utils.messageBox({
                                type: "error",
                                message: data && data.msg || '发生错误',
                            });
                        }
                        if (data instanceof Blob) {
                            let reader = new FileReader()
                            reader.readAsText(data, 'utf-8')
                            reader.onload = () => {
                                showErr(JSON.parse(reader.result))
                            }
                        } else {
                            showErr(data)
                        }
                    }
                } else {
                    let { code, result, msg } = data
                    if (code == '200' || result === 'ok' || data.code === '200' || data.data && data.data.result === 'ok') {
                        return Promise.resolve(data)
                    } else if (code == '401') {
                        utils.messageBox({
                            type: "error",
                            message: msg,
                        });
                        store.dispatch('user/logout', { diableGetAuth: true })                        
                    } else {
                        !response.config.hideMsg && utils.messageBox({
                            type: "error",
                            message: msg || data.data.msg,
                        });
                        return Promise.reject(data)
                    }
                }
            }
            return Promise.reject(response)
        }, error => {
            loadingManage.close()
            return Promise.reject(error)
        })
    }

    get(url, params, config) {
        return this.createAxiosInstance(config).request({
            url,
            params
        })
    }

    post(url, data, config) {
        return this.createAxiosInstance(config).request({
            method: 'post',
            url,
            data
        })
    }

    put(url, data, config) {
        return this.createAxiosInstance(config).request({
            method: 'put',
            url,
            data
        })
    }
}